module.exports = __webpack_public_path__ + "img/2.59ac6988.png";